module.exports = __webpack_public_path__ + "asset/backImg03_K7Twgvce.png";